import { render, staticRenderFns } from "./SiteBillingProposal.vue?vue&type=template&id=8edc8154&scoped=true"
import script from "./SiteBillingProposal.vue?vue&type=script&lang=js"
export * from "./SiteBillingProposal.vue?vue&type=script&lang=js"
import style0 from "./SiteBillingProposal.vue?vue&type=style&index=0&id=8edc8154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edc8154",
  null
  
)

export default component.exports